import { ISelectOption } from 'components/forms/Selects'

export enum RATE_TYPE_DISPLAY {
  'contract_rpm' = 'RPM',
  'contract_linehaul' = 'Linehaul',
  'contract_all_in' = 'All-in',
}

export enum RATE_TYPE {
  'RPM' = 'contract_rpm',
  'Linehaul' = 'contract_linehaul',
  'All-in' = 'contract_all_in',
  'Min Charge' = 'contract_min',
}

export enum AWARD_TYPE {
  primary = 'primary',
  backup = 'backup',
  published = 'published',
}

export enum VOLUME_TYPE {
  gross = 'gross',
  weekly = 'weekly',
  monthly = 'monthly',
  quarterly = 'quarterly',
  annual = 'annual',
}

export interface IRate {
  id: string
  amount: string
  rateTypeKey: RATE_TYPE
  createdById: number
}

export interface IEquipmentType extends ISelectOption<number> {}

export interface IEquipment {
  id: string
  key: string
  name: string
  parentId: number
}

export interface IAccountManager {
  id: string
  firstName: string
  lastName: string
}

export interface IShipperApplication {
  id: string
  name: string
  opsRep?: IAccountManager
}

export interface IDatMarketLane {
  laneMarketId: string
  originId: string
  destinationId: string
}

export interface IShipperLane {
  id?: string
  shipperLaneId?: string
  rfpName?: string
  shipperApplication?: IShipperApplication
  equipment: IEquipment
  pickupPostalCode: string
  pickupPostalCode3: string
  pickupCity: string
  pickupStateCode: string
  pickupIsoCountryCode: string
  deliveryPostalCode: string
  deliveryPostalCode3: string
  deliveryCity: string
  deliveryStateCode: string
  deliveryIsoCountryCode: string
  datMarketLane?: IDatMarketLane
  isPickupDrop?: boolean
  isDeliveryDrop?: boolean
  shipperRateCount?: number
  startDate: string
  endDate?: string
  awardType: AWARD_TYPE
  rate?: IRate
}

export interface IShipperLanesState {
  shipperLanes: IShipperLane[]
  shipperLaneCounts: number[]
  fetching: boolean
  error?: string
  totalCount: number
  params: IShipperLanesParams
}
export interface IShipperLanesFilterState {
  id?: string
  pickupCity?: string
  pickupStateCode?: string
  pickupPostalCode?: string
  deliveryCity?: string
  deliveryStateCode?: string
  deliveryPostalCode?: string
  equipmentId?: number
  shipperApplicationId?: number
  shipperName?: string
  opsRepId?: number
  opsRepName?: string
  activeStatus?: SHIPPER_LANE_STATUS
}

export interface IShipperLanesParams {
  pageCount: number
  perPage: number
  filters?: IShipperLanesFilterState
  sortField?: SORT_FIELD
  sortOrder?: SORT_ORDER
}

export enum SHIPPER_LANES_COLUMNS {
  id = 'ID',
  shipper = 'Shipper',
  startDate = 'Start Date',
  endDate = 'End Date',
  equipment = 'Equipment',
  dropType = 'Drop Type',
  origin = 'Origin',
  destination = 'Destination',
  rate = 'Rate',
  rateType = 'Rate Type',
  awardType = 'Award Type',
  ratesOnFile = 'Rates on File',
  accountManager = 'AM',
}

export interface ILocation {
  postalCode?: string
  postalCode3?: string
  city?: string
  state?: string
  stateCode?: string
  isoCountryCode?: string
}

export enum SHIPPER_LANE_STATUS {
  ALL = 'all',
  ACTIVE = 'active',
  UPCOMING = 'upcoming',
  INACTIVE = 'inactive',
}

export enum SORT_FIELD {
  id = 'ID',
  equipment = 'equipment_name',
  origin = 'pickup_city',
  destination = 'delivery_city',
}

export enum SORT_ORDER {
  ASC = 'asc',
  DESC = 'desc',
}
